export default {
  // Common
  'common.codeExample': 'Contoh Kode',
  'common.tryItYourself': 'Coba sendiri',
  'common.output': 'Keluaran',
  'common.explanation': 'Penjelasan',
  'common.bestPractices': 'Praktik Terbaik',
  'common.commonMistakes': 'Kesalahan Umum',
  'common.relatedFunctions': 'Fungsi Terkait',

  // MySQL Timestamp Page
  'mysql.mainTitle': 'Panduan Lengkap Timestamp MySQL',
  'mysql.mainTitleSEO': 'Tutorial Timestamp MySQL - Panduan UNIX_TIMESTAMP & FROM_UNIXTIME',
  'mysql.subtitle': 'Kuasai fungsi timestamp MySQL, tipe data, dan penanganan zona waktu',

  'mysql.intro': 'MySQL menyediakan fungsi yang kuat untuk bekerja dengan timestamp Unix. Panduan ini mencakup semuanya mulai dari fungsi timestamp dasar hingga penanganan zona waktu tingkat lanjut.',

  // UNIX_TIMESTAMP() Section
  'mysql.unixTimestampTitle': 'Fungsi UNIX_TIMESTAMP()',
  'mysql.unixTimestampDesc': 'Mengkonversi tanggal/datetime ke timestamp Unix (detik sejak 1970-01-01 00:00:00 UTC)',
  'mysql.getCurrentTimestamp': 'Dapatkan Timestamp Unix Saat Ini',
  'mysql.convertDateToTimestamp': 'Konversi Tanggal ke Timestamp',
  'mysql.example1': 'Mengembalikan timestamp Unix saat ini dalam detik',
  'mysql.example2': 'Konversi datetime spesifik ke timestamp',

  // FROM_UNIXTIME() Section
  'mysql.fromUnixtimeTitle': 'Fungsi FROM_UNIXTIME()',
  'mysql.fromUnixtimeDesc': 'Mengkonversi timestamp Unix ke format datetime MySQL',
  'mysql.convertTimestampToDate': 'Konversi Timestamp ke Datetime',
  'mysql.formatTimestamp': 'Format Timestamp dengan Pola Kustom',

  // TIMESTAMP vs DATETIME
  'mysql.typesTitle': 'Tipe Data TIMESTAMP vs DATETIME',
  'mysql.timestampType': 'Tipe TIMESTAMP',
  'mysql.timestampFeature1': 'Rentang: 1970-01-01 hingga 2038-01-19',
  'mysql.timestampFeature2': 'Disimpan dalam UTC, dikonversi ke zona waktu lokal',
  'mysql.timestampFeature3': 'Diperbarui secara otomatis pada INSERT/UPDATE',
  'mysql.timestampFeature4': 'Menggunakan 4 byte penyimpanan',

  'mysql.datetimeType': 'Tipe DATETIME',
  'mysql.datetimeFeature1': 'Rentang: 1000-01-01 hingga 9999-12-31',
  'mysql.datetimeFeature2': 'Disimpan apa adanya, tanpa konversi zona waktu',
  'mysql.datetimeFeature3': 'Diperbarui secara manual',
  'mysql.datetimeFeature4': 'Menggunakan 8 byte penyimpanan',

  // Practical Examples
  'mysql.practicalTitle': 'Contoh SQL Praktis',
  'mysql.example.insert': 'Masukkan Timestamp Saat Ini',
  'mysql.example.query': 'Query Record berdasarkan Rentang Timestamp',
  'mysql.example.update': 'Perbarui Kolom Timestamp',
  'mysql.example.aggregation': 'Agregasi Timestamp',

  // Timezone Handling
  'mysql.timezoneTitle': 'Penanganan Zona Waktu di MySQL',
  'mysql.timezoneDesc': 'MySQL menyimpan nilai TIMESTAMP dalam UTC dan mengonversinya ke zona waktu koneksi',
  'mysql.setTimezone': 'Atur Zona Waktu Sesi',
  'mysql.convertTimezone': 'Konversi Antar Zona Waktu',

  // Common Use Cases
  'mysql.useCasesTitle': 'Kasus Penggunaan Umum',
  'mysql.useCase1.title': 'Lacak Waktu Pembuatan Record',
  'mysql.useCase1.desc': 'Gunakan DEFAULT CURRENT_TIMESTAMP untuk mengatur waktu pembuatan secara otomatis',

  'mysql.useCase2.title': 'Lacak Waktu Pembaruan Terakhir',
  'mysql.useCase2.desc': 'Gunakan ON UPDATE CURRENT_TIMESTAMP untuk memperbarui waktu modifikasi secara otomatis',

  'mysql.useCase3.title': 'Filter berdasarkan Rentang Tanggal',
  'mysql.useCase3.desc': 'Gunakan UNIX_TIMESTAMP() untuk memfilter record berdasarkan rentang timestamp',

  'mysql.useCase4.title': 'Kelompokkan berdasarkan Periode Waktu',
  'mysql.useCase4.desc': 'Gunakan FROM_UNIXTIME() dengan DATE_FORMAT() untuk mengelompokkan record',

  // Performance Tips
  'mysql.performanceTitle': 'Tips Optimasi Kinerja',
  'mysql.perf1': 'Indeks kolom timestamp yang digunakan dalam klausa WHERE',
  'mysql.perf2': 'Gunakan TIMESTAMP untuk kolom yang memerlukan konversi zona waktu',
  'mysql.perf3': 'Gunakan DATETIME untuk tanggal historis di luar rentang TIMESTAMP',
  'mysql.perf4': 'Hindari menggunakan fungsi dalam klausa WHERE - gunakan kolom terindeks',

  // FAQ
  'mysql.faq.q1': 'Apa itu Masalah Tahun 2038 di MySQL?',
  'mysql.faq.a1': 'TIMESTAMP menggunakan integer bertanda 32-bit, yang akan meluap pada 19 Januari 2038. Gunakan DATETIME untuk tanggal setelah 2038.',

  'mysql.faq.q2': 'Bagaimana cara menyimpan milidetik di MySQL?',
  'mysql.faq.a2': 'Gunakan BIGINT untuk menyimpan timestamp Unix dalam milidetik, atau DATETIME(3) untuk datetime dengan presisi milidetik.',

  'mysql.faq.q3': 'Haruskah saya menggunakan TIMESTAMP atau DATETIME?',
  'mysql.faq.a3': 'Gunakan TIMESTAMP untuk tanggal terkini dengan kesadaran zona waktu. Gunakan DATETIME untuk tanggal historis atau saat konversi zona waktu tidak diperlukan.',

  'mysql.faq.q4': 'Bagaimana cara menangani zona waktu di MySQL?',
  'mysql.faq.a4': 'Simpan semua timestamp dalam UTC menggunakan tipe TIMESTAMP, lalu konversi ke zona waktu lokal saat menampilkan.',

  // Python Timestamp Page
  'python.mainTitle': 'Panduan Lengkap Timestamp Python',
  'python.mainTitleSEO': 'Tutorial Timestamp Python - Panduan Modul datetime, time, calendar',
  'python.subtitle': 'Kuasai penanganan timestamp Python dengan modul datetime, time, dan calendar',

  'python.intro': 'Python menyediakan beberapa modul untuk bekerja dengan timestamp. Panduan komprehensif ini mencakup time, datetime, calendar, dan penanganan zona waktu.',

  // Get Current Timestamp
  'python.getCurrentTitle': 'Dapatkan Timestamp Unix Saat Ini',
  'python.getCurrentDesc': 'Berbagai cara untuk mendapatkan timestamp Unix saat ini di Python',
  'python.method1': 'Menggunakan time.time() - Mengembalikan float',
  'python.method2': 'Menggunakan datetime.now() - Mengembalikan integer',
  'python.method3': 'Menggunakan modul calendar',

  // Convert Timestamp to Datetime
  'python.toDatetimeTitle': 'Konversi Timestamp ke Datetime',
  'python.toDatetimeDesc': 'Konversi timestamp Unix ke objek datetime Python',
  'python.fromTimestamp': 'Menggunakan datetime.fromtimestamp()',
  'python.formatDatetime': 'Format String Datetime',
  'python.timezoneAware': 'Datetime Sadar Zona Waktu',

  // Convert Datetime to Timestamp
  'python.toTimestampTitle': 'Konversi Datetime ke Timestamp',
  'python.toTimestampDesc': 'Konversi objek datetime Python ke timestamp Unix',
  'python.usingTimestamp': 'Menggunakan metode .timestamp()',
  'python.usingMktime': 'Menggunakan time.mktime()',

  // Timezone Handling
  'python.timezoneTitle': 'Penanganan Zona Waktu',
  'python.timezoneDesc': 'Bekerja dengan zona waktu menggunakan pytz dan zoneinfo',
  'python.pytzExample': 'Menggunakan library pytz',
  'python.zoneinfoExample': 'Menggunakan zoneinfo (Python 3.9+)',

  // Common Patterns
  'python.patternsTitle': 'Pola & Kasus Penggunaan Umum',
  'python.pattern1.title': 'Aritmatika Timestamp',
  'python.pattern1.desc': 'Tambah atau kurangi waktu dari timestamp',

  'python.pattern2.title': 'Bandingkan Timestamp',
  'python.pattern2.desc': 'Bandingkan dua timestamp untuk menemukan perbedaan waktu',

  'python.pattern3.title': 'Bulatkan Timestamp',
  'python.pattern3.desc': 'Bulatkan timestamp ke hari/jam/menit terdekat',

  'python.pattern4.title': 'Parse String ke Timestamp',
  'python.pattern4.desc': 'Konversi string tanggal ke timestamp',

  // JavaScript Timestamp Page
  'javascript.mainTitle': 'Panduan Lengkap Timestamp JavaScript',
  'javascript.mainTitleSEO': 'Tutorial Timestamp JavaScript - Panduan Objek Date & Metode',
  'javascript.subtitle': 'Kuasai objek Date JavaScript, metode timestamp, dan penanganan zona waktu',

  'javascript.intro': 'JavaScript menyediakan objek Date untuk bekerja dengan timestamp. Panduan ini mencakup semuanya mulai dari metode dasar hingga penanganan zona waktu tingkat lanjut.',

  // Get Current Timestamp
  'javascript.getCurrentTitle': 'Dapatkan Timestamp Unix Saat Ini',
  'javascript.getCurrentDesc': 'Berbagai cara untuk mendapatkan timestamp saat ini di JavaScript',
  'javascript.dateNow': 'Menggunakan Date.now() - Paling efisien',
  'javascript.getTime': 'Menggunakan new Date().getTime()',
  'javascript.valueOf': 'Menggunakan metode valueOf()',
  'javascript.unaryPlus': 'Menggunakan operator unary +',

  // Convert Timestamp to Date
  'javascript.toDateTitle': 'Konversi Timestamp ke Date',
  'javascript.toDateDesc': 'Konversi timestamp Unix ke objek Date JavaScript',
  'javascript.newDate': 'Buat Date dari timestamp',
  'javascript.formatDate': 'Format String Date',
  'javascript.toLocaleString': 'Menggunakan toLocaleString() untuk formatting',

  // Convert Date to Timestamp
  'javascript.toTimestampTitle': 'Konversi Date ke Timestamp',
  'javascript.toTimestampDesc': 'Konversi Date JavaScript ke timestamp Unix',
  'javascript.parseDate': 'Parse string tanggal ke timestamp',
  'javascript.dateComponents': 'Buat timestamp dari komponen',

  // Date Libraries
  'javascript.librariesTitle': 'Library Date Populer',
  'javascript.momentJs': 'Moment.js (Legacy)',
  'javascript.dayJs': 'Day.js (Ringan)',
  'javascript.dateFns': 'date-fns (Modern)',
  'javascript.luxon': 'Luxon (Sadar zona waktu)',

  // Java & PHP - Similar structure
  'java.mainTitle': 'Panduan Lengkap Timestamp Java',
  'java.mainTitleSEO': 'Tutorial Timestamp Java - Panduan Date, Calendar, Instant',
  'java.subtitle': 'Kuasai penanganan timestamp Java dengan Date, Calendar, Instant, dan LocalDateTime',
  'java.intro': 'Java menyediakan beberapa API untuk bekerja dengan timestamp. Panduan ini mencakup kelas Date/Calendar lawas dan API java.time modern (Java 8+).',

  // Get Current Timestamp
  'java.getCurrentTitle': 'Dapatkan Timestamp Unix Saat Ini',
  'java.getCurrentDesc': 'Berbagai cara untuk mendapatkan timestamp saat ini di Java',
  'java.method1': 'Menggunakan System.currentTimeMillis() - Tercepat',
  'java.method2': 'Menggunakan Instant.now() - Modern (Java 8+)',
  'java.method3': 'Menggunakan kelas Date - Legacy',

  // Convert Timestamp to Date
  'java.toDateTitle': 'Konversi Timestamp ke Date',
  'java.toDateDesc': 'Konversi timestamp Unix ke Date/Instant/LocalDateTime Java',
  'java.fromTimestamp': 'Menggunakan Instant.ofEpochSecond()',
  'java.toLocalDateTime': 'Konversi ke LocalDateTime',
  'java.formatDate': 'Format dengan DateTimeFormatter',

  // Convert Date to Timestamp
  'java.toTimestampTitle': 'Konversi Date ke Timestamp',
  'java.toTimestampDesc': 'Konversi Date/Instant/LocalDateTime Java ke timestamp Unix',
  'java.dateToTimestamp': 'Menggunakan Date.getTime()',
  'java.instantToTimestamp': 'Menggunakan metode Instant',

  // Timezone Handling
  'java.timezoneTitle': 'Penanganan Zona Waktu',
  'java.timezoneDesc': 'Bekerja dengan zona waktu menggunakan ZoneId dan ZonedDateTime',
  'java.zoneIdExample': 'Menggunakan ZoneId',
  'java.zonedDateTimeExample': 'Menggunakan ZonedDateTime',

  // Common Patterns
  'java.patternsTitle': 'Pola Timestamp Java Umum',
  'java.pattern1.title': 'Aritmatika Date',
  'java.pattern1.desc': 'Tambah atau kurangi waktu menggunakan Duration dan Period',
  'java.pattern2.title': 'Parse String Tanggal',
  'java.pattern2.desc': 'Parse string ke timestamp menggunakan DateTimeFormatter',
  'java.pattern3.title': 'Bandingkan Timestamp',
  'java.pattern3.desc': 'Bandingkan tanggal dan hitung perbedaan',

  'php.mainTitle': 'Panduan Lengkap Timestamp PHP',
  'php.mainTitleSEO': 'Tutorial Timestamp PHP - Panduan time(), strtotime(), DateTime',
  'php.subtitle': 'Kuasai penanganan timestamp PHP dengan time(), date(), strtotime(), dan kelas DateTime',
  'php.intro': 'PHP menyediakan fungsi yang kuat untuk bekerja dengan timestamp. Panduan ini mencakup fungsi prosedural dan kelas DateTime berorientasi objek.',

  // Get Current Timestamp
  'php.getCurrentTitle': 'Dapatkan Timestamp Unix Saat Ini',
  'php.getCurrentDesc': 'Berbagai cara untuk mendapatkan timestamp saat ini di PHP',
  'php.method1': 'Menggunakan time() - Paling umum',
  'php.method2': 'Menggunakan microtime() - Dengan mikrodetik',
  'php.method3': 'Menggunakan kelas DateTime',

  // Convert Timestamp to Date
  'php.toDateTitle': 'Konversi Timestamp ke Date',
  'php.toDateDesc': 'Konversi timestamp Unix ke string tanggal yang diformat',
  'php.dateFunction': 'Menggunakan fungsi date()',
  'php.dateTimeClass': 'Menggunakan kelas DateTime',
  'php.formatDate': 'Format tanggal kustom',

  // Convert Date to Timestamp
  'php.toTimestampTitle': 'Konversi Date ke Timestamp',
  'php.toTimestampDesc': 'Konversi string tanggal ke timestamp Unix',
  'php.strtotime': 'Menggunakan strtotime() - Parse teks bahasa Inggris',
  'php.dateTimeToTimestamp': 'Menggunakan DateTime::getTimestamp()',

  // Timezone Handling
  'php.timezoneTitle': 'Penanganan Zona Waktu',
  'php.timezoneDesc': 'Bekerja dengan zona waktu menggunakan DateTimeZone',
  'php.setTimezone': 'Atur zona waktu default',
  'php.dateTimeZone': 'Menggunakan kelas DateTimeZone',

  // Common Patterns
  'php.patternsTitle': 'Pola Timestamp PHP Umum',
  'php.pattern1.title': 'Aritmatika Date',
  'php.pattern1.desc': 'Tambah atau kurangi waktu menggunakan strtotime() atau DateInterval',
  'php.pattern2.title': 'Parse Tanggal Relatif',
  'php.pattern2.desc': 'Parse "next Monday", "last week", dll.',
  'php.pattern3.title': 'Bandingkan Timestamp',
  'php.pattern3.desc': 'Bandingkan tanggal dan hitung perbedaan',

  // SQL Timestamp Page (Universal - MySQL, PostgreSQL, Oracle, SQL Server)
  'sql.mainTitle': 'Panduan Lengkap Timestamp SQL',
  'sql.mainTitleSEO': 'Tutorial Timestamp SQL - MySQL, PostgreSQL, Oracle, SQL Server',
  'sql.subtitle': 'Kuasai penanganan timestamp di database MySQL, PostgreSQL, Oracle, dan SQL Server',

  'sql.intro': 'Bekerja dengan timestamp Unix bervariasi di berbagai database SQL. Panduan komprehensif ini mencakup fungsi timestamp untuk MySQL, PostgreSQL, Oracle, dan SQL Server, membantu Anda mengonversi antara timestamp Unix dan format datetime database.',

  // Database Selection
  'sql.selectDatabase': 'Pilih Database Anda',

  // Comparison
  'sql.comparisonTitle': 'Referensi Cepat: Fungsi Timestamp di Berbagai Database',

  // Common Use Cases
  'sql.commonUseCases': 'Kasus Penggunaan Umum di Semua Database',
  'sql.useCase1.title': 'Simpan Timestamp Pembuatan',
  'sql.useCase1.desc': 'Lacak secara otomatis kapan record dibuat menggunakan nilai timestamp default',
  'sql.useCase2.title': 'Lacak Waktu Pembaruan Terakhir',
  'sql.useCase2.desc': 'Perbarui timestamp modifikasi secara otomatis saat record berubah',
  'sql.useCase3.title': 'Filter berdasarkan Rentang Tanggal',
  'sql.useCase3.desc': 'Query record dalam rentang timestamp spesifik untuk analitik dan pelaporan',
  'sql.useCase4.title': 'Kelompokkan berdasarkan Periode Waktu',
  'sql.useCase4.desc': 'Agregat data berdasarkan jam, hari, bulan, atau tahun menggunakan fungsi timestamp',

  // Best Practices
  'sql.bestPractice1': 'Selalu simpan timestamp dalam UTC untuk menghindari kebingungan zona waktu',
  'sql.bestPractice2': 'Indeks kolom timestamp yang sering digunakan dalam klausa WHERE untuk kinerja lebih baik',
  'sql.bestPractice3': 'Gunakan fungsi native database daripada konversi di kode aplikasi jika memungkinkan',
  'sql.bestPractice4': 'Waspadai Masalah Tahun 2038 saat menggunakan timestamp integer 32-bit',
  'sql.bestPractice5': 'Gunakan BIGINT untuk timestamp milidetik untuk menghindari masalah overflow',
};